var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mcs-card',{staticClass:"greyLight",attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"titleSizeClass":"body-1 font-weight-bold","subtitleSizeClass":"body-2"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }